export default function getStackTrace() {
    let obj:any = {}
    Error.captureStackTrace(obj, getStackTrace)

    return obj.stack
        .split('\n')
        .slice(2)
        .map((line:string) => line.replace(/\s+at\s+/, ''))
        // .join('\n')
}
